module.exports = __webpack_public_path__ + "static/img/led_l_1.5afdcff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/led/led_l_1.png
// module id = MWoR
// module chunks = 4